module.exports = {"id":"dp2_1l1q5","text":"Interacting Through Digital Technologies","instructions":"Which interaction involves human-to-machine communication?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l1q5-a1","text":"Giving a command to a chatbot","score":1.8},{"id":"dp2_1l1q5-a2","text":"Talking with a colleague","score":0},{"id":"dp2_1l1q5-a3","text":"Reading a printed document","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l1q5.json
// module id = 990
// module chunks = 41